/**
 * Enum of all modes DataGrid can operate in
 * You can find more information about modes (so called Row Models) on https://www.ag-grid.com/react-grid/row-models/
 * Just keep in mind that Platform DataGrid should simplify AgGrid usage, therefore some functionalities can be partially or entirely disabled (eg. viewport row model)
 **/
export enum DataGridMode {
  /** Server Side mode loads paginated, sorted and filtered data with provided rowsGetter (usually from server) */
  serverSide = 'serverSide',
  /** Client Side mode gets all data in props, all actions like paging, filtering and sorting are done on client */
  clientSide = 'clientSide',
}
